import React from 'react';
import { motion } from 'framer-motion';
import { Users, DollarSign, Megaphone } from 'lucide-react';
const actions = [{
  title: 'Volunteer',
  description: 'Knock doors, make phone calls, and help us connect with voters across the district. Every hour counts.',
  icon: Users,
  buttonText: 'Sign Up',
  link: '/volunteer'
}, {
  title: 'Donate',
  description: 'Our campaign is powered by grassroots supporters like you, not corporate PACs. Chip in today.',
  icon: DollarSign,
  buttonText: 'Contribute',
  link: 'https://secure.actblue.com/donate/guzman_va_web'
}, {
  title: 'Spread the Word',
  description: 'Follow us on social media and share our message with your friends, family, and neighbors.',
  icon: Megaphone,
  buttonText: 'Get Toolkit',
  link: '/media'
}];
export function GetInvolved() {
  return <section id="get-involved" className="py-24 md:py-32 bg-warmgray" data-id="element-104">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-105">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-106">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-107">
            <h2 className="text-4xl md:text-5xl font-serif text-navy mb-6" data-id="element-108">
              Join the <span className="italic text-red" data-id="element-109">Movement</span>
            </h2>
            <p className="text-lg text-navy/70 font-light" data-id="element-110">
              This campaign is about all of us. We can't win without your help.
              Choose how you want to get involved and let's make history
              together by sending the first Latina from the Commonwealth of
              Virginia to Congress.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-16 rounded-sm overflow-hidden shadow-xl max-h-[400px]" data-id="element-111">
          <img src="https://cdn.magicpatterns.com/uploads/mJfk5WWcQht3Toa7tL5ihy/Elizabeth_Guzman-Small_group_talking-80.jpg" alt="Elizabeth Guzmán speaking with constituents" className="w-full h-full object-cover object-center" data-id="element-112" />
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-113">
          {actions.map((action, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="bg-white p-10 rounded-sm shadow-sm text-center flex flex-col items-center group hover:shadow-xl transition-shadow duration-300" data-id="element-114">
              <div className="w-20 h-20 bg-warmgray rounded-full flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-300" data-id="element-115">
                <action.icon className="text-navy" size={32} strokeWidth={1.5} data-id="element-116" />
              </div>
              <h3 className="text-2xl font-serif text-navy mb-4" data-id="element-117">
                {action.title}
              </h3>
              <p className="text-navy/70 font-light mb-8 flex-grow" data-id="element-118">
                {action.description}
              </p>
              <a href={action.link} target={action.link.startsWith('http') ? '_blank' : undefined} rel={action.link.startsWith('http') ? 'noopener noreferrer' : undefined} onClick={e => {
            if (action.link.startsWith('mailto:')) {
              e.preventDefault();
              window.open(action.link, '_self');
            }
          }} className="w-full block text-center bg-navy hover:bg-red text-white font-bold text-sm tracking-widest uppercase py-4 rounded-sm transition-colors" data-id="element-119">
                {action.buttonText}
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}